import { Stack, Text } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IAppPricingTablePlanProps = IContainerProps & {
  title: React.ReactNode;
  supportingText?: React.ReactNode;
  children?: React.ReactNode;
};

const styles = stylex.create({
  host: {
    alignSelf: 'start',
    justifySelf: 'center',
    textAlign: 'center',
  },
});

export const AppPricingTablePlan: React.FC<IAppPricingTablePlanProps> = (
  props,
) => {
  const { sx, title, supportingText, children } = props;

  return (
    <Stack sx={[sx, styles.host]}>
      <Text variant="title" size="md">
        {title}
      </Text>

      <Stack gap={3}>
        {supportingText && (
          <Text variant="body" size="sm" dimmed>
            {supportingText}
          </Text>
        )}

        {children}
      </Stack>
    </Stack>
  );
};
